/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

// Import your global styles here, including font declarations
import "./src/styles/fonts.css"

// Removed automatic Layout wrapping - pages now manually include Layout component

// You can add other browser API customizations here if needed
// For example, wrapping a root element, etc.
// See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/

// Capture UTM parameters BEFORE any redirect happens
const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]
const UTM_STORAGE_KEY = "montes_utm_data"

export const onClientEntry = () => {
  if (typeof window === "undefined") return

  try {
    const urlParams = new URLSearchParams(window.location.search)
    const storedData = JSON.parse(localStorage.getItem(UTM_STORAGE_KEY) || "{}")
    let updated = false

    // Capture UTM params from URL
    UTM_PARAMS.forEach((param) => {
      const value = urlParams.get(param)
      if (value) {
        storedData[param] = value
        updated = true
      }
    })

    // Capture referrer (only first time)
    if (!storedData.referrer && document.referrer) {
      storedData.referrer = document.referrer
      updated = true
    }

    // Capture landing page (only first time)
    if (!storedData.landing_page) {
      storedData.landing_page = window.location.origin + window.location.pathname
      updated = true
    }

    // Capture first visit timestamp (only first time)
    if (!storedData.first_visit_at) {
      storedData.first_visit_at = new Date().toISOString()
      updated = true
    }

    if (updated) {
      localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(storedData))
    }
  } catch (e) {
    console.error("UTM capture error:", e)
  }
}

// Track Meta Pixel PageView on every route change (SPA navigation)
export const onRouteUpdate = () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "PageView")
  }
}
